module.exports = __webpack_public_path__ + "static/zmigrod_main_5-ec063f9ceaad9e01b568f361141859e1.png";